import { ProjectPathParams, Paths } from '../../../app/router/app.router';
import { FileDownloader } from '../../../ui/components/higher-order/file-downloader.component';
import { Snackbar } from '../../../ui/components/pure/snackbar/snackbar.component';
import { UseQueryListOrdersParams, useQueryGetDeliveriesReport } from '../orders.queries';
import { BookOrderAction } from './actions/book-order/book-order-action.component';
import { OrdersListActions } from './actions/orders-list.actions';
import { useOrdersList } from './hooks/use-orders-list.hook';

export function OrdersListActionsObserver({
  params,
  actions,
  filters
}: {
  params: ProjectPathParams<Paths.orders>;
  actions: ReturnType<typeof useOrdersList>['actions'];
  filters: Partial<UseQueryListOrdersParams>;
}) {
  switch (actions.currentAction) {
    case OrdersListActions.BOOK_ORDER:
      return (
        <BookOrderAction
          projectID={params.projectID}
          onAbort={() => actions.setAction(null)}
          onSuccess={(action: OrdersListActions) => {
            actions.setAction(action);
          }}
        />
      );
    case OrdersListActions.BOOK_ORDER_SUCESS:
      return (
        <Snackbar severity="success" onClose={() => actions.setAction(null)}>
          The order has been booked
        </Snackbar>
      );
    case OrdersListActions.BOOK_AND_DELIVER_ORDER_SUCCESS:
      return (
        <Snackbar severity="success" onClose={() => actions.setAction(null)}>
          The order has been delivered
        </Snackbar>
      );
    case OrdersListActions.DOWNLOAD_CSV:
      return (
        <FileDownloader
          generateFilename={() => `Deliveries Report - ${params.shortcode || 'Project'}.csv`}
          useFile={useQueryGetDeliveriesReport}
          args={[params.projectID, filters]}
          onDone={() => actions.setAction(null)}
        />
      );
    default:
      return null;
  }
}
